var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleDottedTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 357,
    viewBox: "0 0 401 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2823_7035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 401,
    height: 357
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.293,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5859,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.293,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.879,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5859,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.172,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.879,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.465,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.172,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.758,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.465,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.051,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.758,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.344,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.051,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 4,
    r: 4,
    fill: "#E3E0FB"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 45,
    r: 4,
    fill: "#E3E0FB"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 86,
    r: 4,
    fill: "#E3E0FB"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 127,
    r: 4,
    fill: "#E3E0FB"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 168,
    r: 4,
    fill: "#E3E0FB"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 209,
    r: 4,
    fill: "#E3E0FB"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 250,
    r: 4,
    fill: "#E3E0FB"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 291,
    r: 4,
    fill: "#E3E0FB"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.637,
    cy: 332,
    r: 4,
    fill: "#E3E0FB"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 24.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 65.4053,
    r: 4,
    fill: "#E3E0FB"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 106.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 147.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 188.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 229.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 270.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 311.405,
    r: 4,
    fill: "#E3E0FB"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.344,
    cy: 352.405,
    r: 4,
    fill: "#E3E0FB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2823_7035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.083 28.4053L339.083 364L-23.4277 364L339.083 28.4053Z",
    fill: "#F7F6FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleDottedTriangle);
export default __webpack_public_path__ + "static/media/purpleDottedTriangle.ccdcf42ebe9d6da0be59f6d9adaa855e.svg";
export { ForwardRef as ReactComponent };